import styled from "styled-components";
import { SelectButton } from "primereact/selectbutton";

export const Hint = styled.span`
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.darkGrey};
`;

export const FieldLabel = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const SecretBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.small};
  padding: 6px 12px;
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  background-color: ${({ theme }) => theme.colors.white};
`;

export const SecretValue = styled.code`
  word-break: break-all;
  font-size: 0.95rem;
`;

/** Переключатель вида клиента: глобальные стили кнопок красят все варианты, выделяем выбранный. */
export const KindSelect = styled(SelectButton)`
  display: flex;
  flex-wrap: wrap;

  .p-button:not(.p-highlight) {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primary};
    border: 1px solid ${({ theme }) => theme.colors.primary};
  }
`;
